// Copyright (c) 2022 by Move Closer

import { SizeRegistry } from '../../composables'
import { ModalSizeMap } from './Modal.contracts'

/**
 * @author Wojciech Falkowski <wojciech.falkowski@movecloser.pl> (edited)
 */
export const sizeClassRegistry: SizeRegistry<string> = {
  [ModalSizeMap.Full]: '--full',
  [ModalSizeMap.Large]: '--large',
  [ModalSizeMap.Medium]: '--medium',
  [ModalSizeMap.Small]: '--small',
  [ModalSizeMap.XLarge]: '--x-large'
}
